export default __webpack_public_path__ + "static/media/url_shortner.32b2b173.png";